import React from 'react';

export type FooterBottomNavItem = {
  name: string;
  href: string;
};

export type FooterBottomNavProps = {
  navLinks: FooterBottomNavItem[];
};

const FooterBottomNav = ({ navLinks }: FooterBottomNavProps) => {
  return (
    <div className="flex flex-none items-center justify-center pb-2 pt-3 md:justify-end md:pb-0 md:pt-0">
      <div className="flex gap-2 text-black md:gap-4">
        {navLinks.map((item: FooterBottomNavItem, index: number) => (
          <div className="flex gap-2 md:gap-4" key={item.name}>
            <a className="whitespace-nowrap" href={item.href}>
              {item.name}
            </a>
            {index < navLinks.length - 1 && <span>|</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FooterBottomNav;
